import React from 'react';
import ReactDOM from 'react-dom/client';
// Self-hosted fonts — no CDN dependency, no render-blocking @import.
import '@fontsource/manrope/400.css';
import '@fontsource/manrope/500.css';
import '@fontsource/manrope/600.css';
import '@fontsource/manrope/700.css';
import '@fontsource/manrope/800.css';
// Arabic (primary market): picked up through the shared font stack.
import '@fontsource/noto-sans-arabic/400.css';
import '@fontsource/noto-sans-arabic/500.css';
import '@fontsource/noto-sans-arabic/600.css';
import '@fontsource/noto-sans-arabic/700.css';
// Design tokens must be defined before any stylesheet that reads them.
import './styles/tokens.css';
import './index.css';
// Small-screen and touch rules. Must come after index.css and the Tailwind
// layers so equal-specificity selectors here win by source order.
import './styles/responsive.css';
// Shared spacing rhythm for dashboards (page edge, gutters, sections, cards).
import './styles/dashboard.css';
// Shared UI kit (select chevron, dialog motion).
import './styles/kit.css';
// Load the Inbox stylesheet eagerly (main bundle) instead of in the lazy route
// chunk. In CRA dev, style-loader injects each lazy chunk's <style> at
// navigation time and leaves it in place, so styling becomes nav-order
// dependent — the Inbox (largest stylesheet) intermittently rendered unstyled
// until a refresh. Loading it here makes it deterministic. All selectors are
// cx_-prefixed, so it has no effect on other pages.
import './pages/inbox/Inbox.css';
// Same reason for these shared stylesheets: route chunks import them in
// different orders (Nexus pages import Header.css after Nexus.css, detail
// layouts import the filter dropdown and right-detail header both ways round),
// so mini-css-extract cannot pick one cascade order and reports "Conflicting
// order", which fails the build when CI=true. Loading them once in the main
// bundle pins their position before any route chunk.
import './pages/components/Header.css';
import './pages/components/common_filter_dropdown.css';
import './pages/components/common-rightdetails/common-rightdetails-header.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import {
  isChunkLoadError,
  isChunkResourceEvent,
  attemptChunkReload,
} from './utils/chunkReload';

// Production builds keep console.log/debug calls out of the browser console.
// Errors and warnings still surface. CRA has no build-time strip without
// ejecting, so this is the cheapest reliable guard.
if (process.env.NODE_ENV === 'production') {
  // eslint-disable-next-line no-console
  console.log = () => {};
  // eslint-disable-next-line no-console
  console.debug = () => {};
}

// ── Stale-chunk self-heal ── see src/utils/chunkReload.js for the rationale.
// Registered in the CAPTURE phase: a <link>/<script> that fails to load fires
// `error` on the element itself and does not bubble, so a bubble-phase listener
// on window never sees it. Such events also carry no `.error`, which is why
// isChunkResourceEvent inspects the element URL instead of a message.
window.addEventListener(
  'error',
  (event) => {
    if (isChunkResourceEvent(event) || isChunkLoadError(event.error)) {
      event.preventDefault?.();
      attemptChunkReload();
    }
  },
  true
);

window.addEventListener('unhandledrejection', (event) => {
  if (isChunkLoadError(event.reason)) {
    event.preventDefault?.();
    attemptChunkReload();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
